import { DataBean } from "../DataBean";

export class PhysicalTakingForAction extends DataBean {


    public async getPhysicalTakingConstantsForAction(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPhysicalTakingConstantsForAction_Number", [id]);
    }

    //aqui

 
}